import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "modalEditSuccess",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header d-flex justify-content-center" }
const _hoisted_5 = { class: "modal-title text-center fw-bold w-100" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1)
const _hoisted_7 = { class: "content mx-auto" }
const _hoisted_8 = {
  key: 0,
  class: "text-center py-4"
}
const _hoisted_9 = {
  key: 1,
  class: "text-center py-4"
}
const _hoisted_10 = {
  key: 2,
  class: "text-center py-4 while-spaces mx-3"
}
const _hoisted_11 = { class: "modal-footer d-flex justify-content-center" }

import { useRouter } from 'vue-router'

import Button from '@/components/button/index.vue'
import { translate } from '@/languages/i18n'
import { PropType } from 'vue'
import { getMessage } from '@/constants/messageCode.ts'


export default /*#__PURE__*/_defineComponent({
  props: {
  data: Object as PropType<any>,
  serverError: Boolean,
},
  setup(__props) {

const router = useRouter()


const transitCI10 = (): void => {
  router.push(`/community/communities/${router.currentRoute.value.params?.id}/alumnus_candidates_waiting_approval?management_no=asc`)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString(_unref(translate)('confirmExaminationResult')), 1),
          _hoisted_6
        ]),
        _createElementVNode("div", _hoisted_7, [
          (__props.serverError === 'success')
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_unref(translate)('CI10updateCompletedApprove')), 1))
            : (_ctx.updateError)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_unref(translate)(__props.data?.examinated ? 'CI40ApprovalError' : 'CI40RejectionError')), 1))
              : (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_unref(getMessage)(__props.serverError)), 1))
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(Button, {
            title: _unref(translate)('close'),
            type: 'secondary',
            "data-bs-dismiss": "modal",
            onClick: transitCI10
          }, null, 8, ["title"])
        ])
      ])
    ])
  ]))
}
}

})